module.exports = __webpack_public_path__ + "static/media/stonehenge.25ad79fe.jpg";